
'use client';

import * as React from 'react';
import { ScrollArea } from './ui/scroll-area';
import SunnahSection from './sunnah-section';
import { Info } from 'lucide-react';


export default function SunnahView() {
  return (
    <div className="flex flex-col h-full bg-background">
      <header className="p-4 border-b sticky top-0 bg-background z-10">
        <h1 className="text-xl md:text-2xl font-bold text-foreground">Sunnahs</h1>
      </header>
      <div className="flex-1 flex flex-col">
        <ScrollArea className="flex-1">
          <div className="p-4 space-y-4">
            <SunnahSection />
          </div>
        </ScrollArea>
        <footer className="p-4 border-t bg-background">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Info className="w-4 h-4" />
            <div>
              <p>The app is still in development, so there might be some bugs and errors.</p>
              <p>Please report if you find any.</p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
